import React from "react";
import { CheckCircle } from "lucide-react";

const QualificationsCard = ({ qualifications }) => {
  const items = Array.isArray(qualifications) ? qualifications : [];

  return (
    <div className="bg-white rounded-2xl shadow-md p-8 border border-gray-200 mt-8">
      <h3 className="font-semibold text-gray-900 text-lg mb-4">
        Qualifications & Experience
      </h3>

      {!items.length ? (
        <p className="text-gray-500">No qualifications provided.</p>
      ) : (
        <ul className="space-y-3">
          {items.map((qualification, i) => (
            <li key={i} className="flex items-center gap-3 text-gray-700">
              <CheckCircle size={20} className="text-[#08A595]" />
              {qualification}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default QualificationsCard;
